module.exports = __webpack_public_path__ + "img/added-services-add.884f8fb2.svg";